import React from 'react';
import InfiniteScrollTable from './InfiniteScrollTable';
import { TableWrapper } from '../styled';

const ArchivedOutliersTable = ({ getColumns }) => {
  return (
    <TableWrapper>
      <InfiniteScrollTable getColumns={getColumns} />
    </TableWrapper>
  );
};

export default ArchivedOutliersTable;
